<template>
  <div class="dashMain">
    <div class="app-navbar">
      <b-container fluid class="appNavContainer">
        <b-row style="padding: 0px 0px 0px 0px">
          <b-col class="navCont" cols="4" style="padding: 0px 0px 0px 0px">
            <b-nav pills  :class="modalTheme" justified style="padding: 3px; height: 25px; font-size: 10pt">
              <b-nav-item to="/emr/Dashboard/Primary">Pop Health</b-nav-item>
              <b-nav-item to="/emr/Dashboard/MyWork">My Work</b-nav-item>
              <!-- <b-nav-item to="/Dashboard/DiseaseManagement"> <span>Disease Mgmt</span> </b-nav-item> -->
            </b-nav>
          </b-col>

          <!-- <UsersFilters /> -->
          <!-- <DashboardInfoBar style="background:darkgoldenrod;padding: 0px 0px 0px 0px;" /> -->
          <b-col style="padding: 2px 0px 0px 0px">
            <DashboardInfoBar />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted,computed } from "vue";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();

import DashboardInfoBar from "@/views/Dashboard/DashboardInfoBar.vue";

import DashboardsContainerNEW from "@/views/Dashboard/DashboardsContainerNEW.vue";

const modalTheme = computed(() => userStore.bModalTheme);


onMounted(() => {
// console.log("onMounted() :      DASHBOARD CONTAINER  NEW  >>>>");
});
</script>


<style lang="scss" scoped>
.aNavBar {
  // padding: 3px;
  width: 100%;
  border-radius: 5px;
  //  background-color: #dcf1de; // #43997848;
  //  color: white; // #42948248;
  // font-size: 14px;
  // margin-left: -1rem;
  // margin-right: -1rem;
  margin-bottom: 0.25rem;
}
.col-6,
.col-4 {
  padding: 0%;
}
.dashBoard {
  border: 3px solid #8c9e06; //069e7d
  padding: 15px;
  border-radius: 5px;
  // background-color: #0d463a;
}
.dashBoardRte {
  border: 2px solid #069e7d; //069e7d
  padding: 15px;
  border-radius: 5px;
  background-color: #0d463a;
}
.bg-light {
  background-color: #b6e6dc !important;
}
.dash-navbar {
  padding: 0px;
  border-radius: 5px;
  background-color: #0ed700; //1b8d74
  // color: white;
  // font-size: 14px;
  // margin-left: -1rem;
  // margin-right: -1rem;
}
.card {
  border: 3px solid #069e7d !important;
  //  padding: 15px;
  border-radius: 5px;
  background-color: #39464344 !important;
  width: 100% !important;
}
.navCard {
  // border-radius: 5px;
  // border: 3px solid #ffae00bd !important;
  padding-top: 5px;
  padding-bottom: 0%;
}
.card-header {
  border-radius: 5px;
  padding-top: 5px;
  padding-bottom: 0%;
}
.card-body {
  // padding:0%;
  // padding: 0.55rem;
}

.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100% !important;
  // padding-right: 5px;
  // padding-left: 5px;
  margin-right: auto;
  margin-left: auto;
}

.app-navbar {
  // padding: 3px;
  // border-radius: 15px;
  ////  background-color: #eef8ef; //#43997848; // ? Simulated OPACITY
  //  color: #dcf1de; //  white; // #42948248;
  // font-size: 14px;
  // margin-left: -1rem;
  // margin-right: -1rem;
  // margin-bottom: 0.25rem;
}
.appNavContainer {
  // background-color: #43997848; // ? Simulated OPACITY
  // background-color:#43997848;
  color: #eef8ef;

  // padding-right:10px;
  // text-decoration: bolder;
  height: 30px;
}
.navCont .nav-link .nav-pills {
  line-height: 40px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  text-align: center;
  // color: orange;
  font-size: 1rem;
  border-radius: 10px 0px 0px 10px;
  // height: 140px;
  width: 30px;
  width: 300px;
  color: #123486;
  border-radius: 10px 0px 0px 10px;
  background-color: transparent;
}

.nav-link {
  display: block;
  padding-top: 0px;
  padding-bottom: 0px;
  // width: 130px;
}
// .nav-tabs .nav-link.active,
// .nav-tabs .nav-item.show .nav-link {
// 	color: #dcf1de; // #eaf7ebc8;
// 	background-color: #43997848;
// 	border-color: #43997848 #43997848 #43997848;
// 	border-radius: 10px;
// 	font-weight: bold;
// }

.nav-pills {
  // background-color: chartreuse;
  // padding:30px;
}
.nav-pills .nav-link.active {
  // background-color: #a5dbaa;
  // color: #123486; // #dcf1de;//#eaf7ebc8;
  // font-weight: bold;
  // // border: 3px ridge #a5dbaa8e;
  // // border: 4mm ridge rgba(211, 220, 50, .6);
  // border-radius: 5px 0px 0px 5px;
  // // border: 3px solid transparent;
  // border-width: 3px 0px 3px 6px;
  // font-weight: bolder;

  // -webkit-box-shadow: 3px 0px 0px 0px #00ff1a inset;
  // box-shadow: 1px 0px 0px 0px #b0c1b2 inset;

  //height: 24px;
  color: #eef8ef;
  background-color: #b0c1b2;
  border-radius: 5px 5px 5px 5px;
  // border-width: 3px 0px 3px 6px;
  font-weight: bolder;
}

.nav-pills .nav-link {
  border-radius: 6px;
  text-align: center;
}

.nav-link:hover,
.nav-link:focus {
  background-color: #caeacd;
  color: #123486;
  border-radius: 5px 5px 5px 5px;
}
</style>
